import { imageBasePath } from 'constants';

export const msgInfo = { sender: 'USER', recipient: 'AI' };
export const tipsText = [
  { title: 'Start from scratch', text: 'Build something unique and original.' },
  { title: 'Powered by you', text: 'You are the engine of innovation.' },
  {
    title: 'Summarize your data',
    text: 'Simplify and distill key information for quick understanding.',
  },
  { title: 'Create with AI', text: 'Collaborate with AI to bring your ideas to life.' },
];

export const errorResponse = {
  text: 'We couldn’t get a response right now. Please try again in a moment.',
  type: 'AI',
};

export const IntroducingNea =
  'Nea is your intelligent sales team co-pilot, giving managers deeper visibility into rep activity, onboarding, pipeline health, and coaching needs—without adding manual overhead.';
export const tipsTextNea = [
  {
    title: 'Coach With Precision',
    text: 'AI pinpoints skill gaps, serves 1‑on‑1 cues.',
    image: `${imageBasePath}nea_1.svg`,
  },
  {
    title: 'Ramp & Onboard Faster',
    text: 'Track progress, surface weekly win tasks.',
    image: `${imageBasePath}nea_2.svg`,
  },
  {
    title: 'Confidence Forecast',
    text: 'AI roll‑up shows commit vs. upside delta.',
    image: `${imageBasePath}nea_3.svg`,
  },
  {
    title: 'Team Sentiment Scan',
    text: 'Pulse survey + text analysis for morale.',
    image: `${imageBasePath}nea_4.svg`,
  },
];

export const IntroducingKai =
  'KAI is your go-to co-pilot for deal execution, product clarity, and sales process support. It empowers reps with quick, accurate answers so they can close with more confidence and fewer delays.';
export const tipsTextKai = [
  {
    title: 'Instant Product Answers',
    text: 'Specs, pricing, & use-cases in one ask.',
    image: `${imageBasePath}kai_1.svg`,
  },
  {
    title: 'Tackle Objections',
    text: 'Ask, practice, ace any pash-back live.',
    image: `${imageBasePath}kai_2.svg`,
  },
  {
    title: 'Craft My Follow-Up',
    text: 'Prepare emails, InMails, or snippets.',
    image: `${imageBasePath}kai_3.svg`,
  },
  {
    title: 'Micro-Lesson Boost',
    text: 'Refresher on product or process or pricing.',
    image: `${imageBasePath}kai_4.svg`,
  },
];
